import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Title } from './Title';
import { Gallery } from './Gallery';
import { PurchasePanel } from './PurchasePanel';
import { Description } from './Description';
import { SuggestedProducts } from './SuggestedProducts';
import { BackButton } from './BackButton';
/**
 * Gen2 E-Chest Gear product detail page.
 *
 * Self-contained: every section lives in `./` and is owned by this page only.
 */
export function Gen2EChestGearPage() {
  return <div className="min-h-screen bg-white flex flex-col font-sans text-gray-900" data-id="element-363">
      <Header data-id="element-364" />

      <main className="flex-grow pt-32 pb-20" data-id="element-365">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-366">
          <Title data-id="element-367" />

          <div className="flex flex-col md:flex-row gap-12 mb-16 items-start" data-id="element-368">
            <Gallery data-id="element-369" />
            <PurchasePanel data-id="element-370" />
          </div>

          <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-371">
            <Description data-id="element-372" />
            <SuggestedProducts data-id="element-373" />
            <BackButton data-id="element-374" />
          </div>
        </div>
      </main>

      <Footer data-id="element-375" />
    </div>;
}